// extracted by mini-css-extract-plugin
export default {"containerError":"styles_containerError__XSGUV","containerImage":"styles_containerImage__xLUz2"};